import { X } from 'lucide-react';
import { formatINR } from '../../lib/quote';
import { IMG_FALLBACK } from '../../lib/images';
import { unitName, kindText, MAX_COMPARE } from '../../data/compare';

// The ACs picked so far, as small cards (each with Change and remove), plus
// "+ Add AC" slots up to the limit.
export default function PickTray({ units, onRemove, onAdd, onChange }) {
  const slots = MAX_COMPARE;
  return (
    <div data-testid="compare-tray" className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
      {units.map((u) => (
        <div key={u.id} data-testid={`tray-card-${u.id}`}
          className="relative flex min-w-0 items-center gap-2 rounded-xl border border-gray-200 bg-white p-2">
          <img src={u.model.image} alt="" width="48" height="48" loading="lazy"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = IMG_FALLBACK; }}
            className={`h-12 w-12 shrink-0 object-contain ${u.soldOut ? 'opacity-40' : ''}`} />
          <div className="min-w-0 flex-1">
            <p className="truncate text-xs font-semibold text-gray-900">{unitName(u)}</p>
            <p className="truncate text-[11px] text-gray-500">{Number(u.model.soldAs).toFixed(1)} Ton · {kindText(u)}</p>
            <p className="text-xs font-bold text-gray-900">{formatINR(u.price)}</p>
            {u.soldOut && <p className="text-[10px] font-semibold text-red-600">Sold out</p>}
            {onChange && (
              <button type="button" onClick={() => onChange(u.id)} data-testid={`tray-change-${u.id}`}
                className="mt-0.5 text-[11px] font-semibold text-blue-700 hover:underline">
                Change
              </button>
            )}
          </div>
          <button type="button" onClick={() => onRemove(u.id)} aria-label={`Remove ${unitName(u)}`}
            data-testid={`tray-remove-${u.id}`}
            className="absolute -right-1.5 -top-1.5 flex h-6 w-6 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 hover:border-red-400 hover:text-red-600">
            <X size={13} aria-hidden="true" />
          </button>
        </div>
      ))}
      {units.length < MAX_COMPARE && Array.from({ length: slots - units.length }).map((_, i) => (
        <button key={`add-${i}`} type="button" onClick={onAdd} data-testid={i === 0 ? 'tray-add-ac' : undefined}
          className="flex h-[68px] items-center justify-center rounded-xl border-2 border-dashed border-blue-300 bg-blue-50/50 text-sm font-semibold text-blue-700 hover:bg-blue-50">
          + Add AC
        </button>
      ))}
    </div>
  );
}
